import { render } from "./TermsandConditions.vue?vue&type=template&id=123f3fa6"
import script from "./TermsandConditions.vue?vue&type=script&lang=js"
export * from "./TermsandConditions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__